import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RealEstateGroupAnalytics } from '@app/real-estate-group/interfaces/real-estate-group-analytics';
import { CardContext } from '@smooved/ui';
import { financialReportRoute } from '../analytics-dashboard/analytics-dashboard.constants';

@Component({
    selector: 'app-analytics-services',
    template: `
        <div class="u-flex-column u-h100p">
            <div class="u-flex-row u-flex-justify-content-space-between u-flex-align-items-center u-margin-y-axis">
                <h4>{{ 'ANALYTICS.COMMISSIONS.LABEL' | translate }}</h4>
                <a app-button appearance="link" [routerLink]="financialReportRoute" [appendIcon]="true" icon="chevron_right">{{
                    'COMMON.DETAILS' | translate
                }}</a>
            </div>

            <div class="grid grid-cols-2 gap-4">
                <app-context-card [border]="false" [context]="cardContext.Muted" class="u-text-align-center">
                    <h3>{{ analytics?.services?.energy }}</h3>
                    <p class="u-font-size-small">{{ 'ANALYTICS.COMMISSIONS.ENERGY_CONTRACTS' | translate }}</p>
                </app-context-card>

                <app-context-card [border]="false" [context]="cardContext.Muted" class="u-text-align-center">
                    <h3>{{ analytics?.services?.telecom }}</h3>
                    <p class="u-font-size-small">{{ 'ANALYTICS.COMMISSIONS.TELECOM_CONTRACTS' | translate }}</p>
                </app-context-card>
            </div>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnalyticsServicesComponent {
    @Input() public analytics: RealEstateGroupAnalytics;

    public cardContext = CardContext;
    public readonly financialReportRoute = financialReportRoute;
}
